/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useState, useMemo } from 'react'
import { State, useHookstate } from '@hookstate/core'
import { Collapse, Grid } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import notify from '~/utils/notify'

import useDispatchRegistrationPersonState from '~/features/Dispatch/stores/DispatchRegistrationPersonState'
import useDispatchRegistrationVehicleState from '~/features/Dispatch/stores/DispatchRegistrationVehicleState'
import useDispatchRegistrationState from '~/features/Dispatch/stores/DispatchRegistrationState'
import useDispatchRegistrationDrugState from '~/features/Dispatch/stores/DispatchRegistrationDrugState'
import useDispatchRegistrationWeaponState from '~/features/Dispatch/stores/DispatchRegistrationWeaponState'
import useDispatchRegistrationObjectState from '~/features/Dispatch/stores/DispatchRegistrationObjectState'
import useDispatchRegistrationAnimalState from '~/features/Dispatch/stores/DispatchRegistrationAnimalState'

import useManagementQualifiersInvolvedState from '~/features/Management/stores/ManagementQualifiersInvolvedState'
import useManagementQualifiersVehicleState from '~/features/Management/stores/ManagementQualifiersVehicleState'
import useManagementQualifiersDrugsState from '~/features/Management/stores/ManagementQualifiersDrugsState'
import useManagementQualifiersWeaponState from '~/features/Management/stores/ManagementQualifiersWeaponState'
import useManagementQualifiersObjectState from '~/features/Management/stores/ManagementQualifiersObjectState'

import InvolvedFilters from './components/InvolvedFilters'
import VehicleFilters from './components/VehicleFilters'
import DrugFilters from './components/DrugFilters'
import WeaponFilters from './components/WeaponFilters'
import ObjectFilters from './components/ObjectFilters'
import AnimalsFilters from './components/AnimalsFilters' // novo
import FiltersFooter from './components/FiltersFooters'

import type {
  IListDispatchTab,
  FilterState,
  InvolvedFilter,
  VehicleFilter,
  WeaponFilter,
  DrugsFilter,
  ObjectsFilter,
  AnimalsFilter,
  IWeaponKind,
  IObjectType,
  IAnimalSpecie,
  IActionTaken,
  OrgansFilter,
  IAuxiliaryOrgans, // <== adicionar no arquivo de interfaces
} from '~/features/Management/interfaces'

import type IInvolvementType from '~/features/InvolvementType/interfaces/IInvolvementType'
import type IPeopleCircunstance from '~/features/PeopleCircunstance/interfaces/IPeopleCircunstance'
import type IDestination from '~/features/Destination/interfaces/IDestination'
import type ICircunstance from '~/features/Circunstance/interfaces/ICircunstance'
import type IVehicleType from '~/features/VehicleType/interfaces/IVehicleType'
import type IDrugType from '~/features/DrugType/interfaces/IDrugType'
import type IWeaponType from '~/features/WeaponType/interfaces/IWeaponType'
import IDrugSituation from './Interface/IDrugSituation'
import useManagementQualifiersAnimalsState from '~/features/Management/stores/ManagementQualifiersAnimalState'
import useManagementQualifiersOrgansState from '~/features/Management/stores/ManagementQualifiersOrgansState' // adicionado
import OrgansFilters from './components/OrgansFilters'
import useDispatchRegistratinOrganState from '~/features/Dispatch/stores/DispatchRegistrationOrganState' // adicionado;

interface ManagementQualifiersFiltersProps {
  readonly involvedTypeFilter?: boolean
  readonly arrestedFilter?: boolean
  readonly peopleCircunstanceFilter?: boolean
  readonly destinationFinalFilter?: boolean
  readonly periodFilter?: boolean
  readonly typeVehicleFilter?: boolean
  readonly vehicleCiscunstanceFilter?: boolean
  readonly weaponTypeFilter?: boolean
  readonly weaponCircunstanceFilter?: boolean
  readonly hidden?: boolean
  readonly loading?: State<boolean>
  readonly disableFields?: boolean
  readonly labelButton?: State<string>
  readonly valueTab?: IListDispatchTab
  readonly disabledSendButton?: () => boolean
  readonly searchButton?: () => void
  readonly clearFilters?: () => void
  readonly filters?: State<FilterState>
  readonly setFilters: (
    filters:
      | InvolvedFilter
      | VehicleFilter
      | WeaponFilter
      | DrugsFilter
      | ObjectsFilter
      | AnimalsFilter
      | OrgansFilter
  ) => void
}

export default function ManagementQualifiersFilters(
  props: ManagementQualifiersFiltersProps
) {
  const {
    hidden,
    loading,
    labelButton,
    disableFields,
    involvedTypeFilter,
    arrestedFilter,
    peopleCircunstanceFilter,
    destinationFinalFilter,
    periodFilter,
    typeVehicleFilter,
    vehicleCiscunstanceFilter,
    valueTab,
    clearFilters,
    searchButton,
    setFilters,
    filters,
  } = props

  const { translate } = useLang()

  // Hookstates (agrupados)
  const involvedType = useHookstate<IInvolvementType | null>(null)
  const arrestedId = useHookstate<number | null>(null)
  const peopleCircunstanceId = useHookstate<IPeopleCircunstance | null>(null)
  const destinationInvolvedId = useHookstate<IDestination | null>(null)

  const destinationVehicleId = useHookstate<IDestination | null>(null)
  const vehicleCiscunstance = useHookstate<ICircunstance | null>(null)
  const vehicleType = useHookstate<IVehicleType | null>(null)

  const drugType = useHookstate<IDrugType | null>(null)
  const drugSituation = useHookstate<IDrugSituation | null>(null)
  const destinationDrugId = useHookstate<IDestination | null>(null)

  const weaponType = useHookstate<IWeaponType | null>(null)
  const weaponKind = useHookstate<IWeaponKind | null>(null)
  const weaponCircunstance = useHookstate<ICircunstance | null>(null)
  const destinationWeaponId = useHookstate<IDestination | null>(null)

  const objectType = useHookstate<IObjectType | null>(null)
  const objectCircunstance = useHookstate<ICircunstance | null>(null)
  const destinationObjectId = useHookstate<IDestination | null>(null)

  const animalSpecie = useHookstate<IAnimalSpecie | null>(null)
  const animalCircunstance = useHookstate<ICircunstance | null>(null)
  const destinationAnimalId = useHookstate<IDestination | null>(null)

  // organs hooks (novo)
  const actionTaken = useHookstate<IActionTaken | null>(null)
  const auxiliaryOrgans = useHookstate<IAuxiliaryOrgans | null>(null)

  const [startDate, setStartDate] = useState<string | null>(null)
  const [finishDate, setFinishDate] = useState<string | null>(null)
  const initialPeriod = useHookstate<string>('')

  // Filtros externos
  const external = filters?.get()
  const involved = external?.involved
  const vehicle = external?.vehicle
  const drug = external?.drugs
  const weapon = external?.weapon
  const object = external?.objects
  const animal = external?.animals // novo
  const organs = external?.organs // novo

  // Fetch de cadastros
  const { getInvolvementTypes, getPeopleCircunstances, getArrestedValues } =
    useDispatchRegistrationPersonState()
  const { getVehicleTypes } = useDispatchRegistrationVehicleState()
  const { getDestinations, getCircunstances } = useDispatchRegistrationState()
  const { getDrugTypes } = useDispatchRegistrationDrugState()
  const { getWeaponTypes, getWeaponKinds } =
    useDispatchRegistrationWeaponState()
  const { getObjectTypes } = useDispatchRegistrationObjectState()
  const { getSpecies } = useDispatchRegistrationAnimalState() // novo
  const { getActionTaken, getAuxiliaryOrgans } = useDispatchRegistratinOrganState()

  // Fetch de dados gerenciais
  const { fetchAllAssociatedPeopleData } =
    useManagementQualifiersInvolvedState()
  const { fetchAllAssociatedVehicleData } =
    useManagementQualifiersVehicleState()
  const { fetchAllAssociatedDrugsData } = useManagementQualifiersDrugsState()
  const { fetchAllAssociatedWeaponData } = useManagementQualifiersWeaponState()
  const { fetchAllAssociatedObjectData } = useManagementQualifiersObjectState()
  const { fetchAllAssociatedAnimalsData } =
    useManagementQualifiersAnimalsState() // novo
  const { fetchAllAssociatedOrgansData } = useManagementQualifiersOrgansState() // novo

  // Helpers
  const deepClone = <ValueType,>(value: ValueType | undefined | null) =>
    value != null ? JSON.parse(JSON.stringify(value)) : null

  const resetStates = (...stateNodes: readonly State<any>[]) =>
    stateNodes.forEach((stateNode) => stateNode.set(null))

  const loadTabState = () => {
    switch (valueTab) {
      case 'involved':
        involvedType.set(deepClone(involved?.involvedType))
        arrestedId.set(
          involved?.arrested !== undefined ? Number(involved.arrested) : null
        )
        peopleCircunstanceId.set(deepClone(involved?.peopleCircunstance))
        destinationInvolvedId.set(deepClone(involved?.destinationFinal))
        initialPeriod.set(involved?.period ?? '')
        break
      case 'vehicle':
        destinationVehicleId.set(deepClone(vehicle?.destinationFinal))
        vehicleType.set(deepClone(vehicle?.typeVehicle))
        vehicleCiscunstance.set(deepClone(vehicle?.vehicleCiscunstance))
        initialPeriod.set(vehicle?.period ?? '')
        break
      case 'drugs':
        destinationDrugId.set(deepClone(drug?.destinationFinal))
        drugType.set(deepClone(drug?.drugType))
        drugSituation.set(deepClone(drug?.drugCategory))
        initialPeriod.set(drug?.period ?? '')
        break
      case 'weapon':
        destinationWeaponId.set(deepClone(weapon?.destinationFinal))
        weaponType.set(deepClone(weapon?.weaponType))
        weaponKind.set(deepClone(weapon?.weaponCategory))
        weaponCircunstance.set(deepClone(weapon?.weaponBrand))
        initialPeriod.set(weapon?.period ?? '')
        break
      case 'objects':
        destinationObjectId.set(deepClone(object?.destinationFinal))
        objectType.set(deepClone(object?.objectType))
        objectCircunstance.set(deepClone(object?.objectCategory))
        initialPeriod.set(object?.period ?? '')
        break
      case 'animals':
        destinationAnimalId.set(deepClone(animal?.destinationFinal))
        animalSpecie.set(deepClone(animal?.animalSpecies))
        animalCircunstance.set(deepClone(animal?.animalCircunstance))
        initialPeriod.set(animal?.period ?? '')
        break
      case 'organs': // novo
        actionTaken.set(deepClone(organs?.actionTakenId))
        auxiliaryOrgans.set(deepClone(organs?.auxiliaryOrgans))
        initialPeriod.set(organs?.period ?? '')
        break
      default:
        break
    }
  }

  useEffect(loadTabState, [
    valueTab,
    involved,
    vehicle,
    drug,
    weapon,
    object,
    animal,
    organs,
  ])

  const handleClearFilters = () => {
    resetStates(
      involvedType,
      arrestedId,
      peopleCircunstanceId,
      destinationInvolvedId,
      destinationVehicleId,
      vehicleCiscunstance,
      vehicleType,
      drugType,
      drugSituation,
      destinationDrugId,
      weaponType,
      weaponCircunstance,
      destinationWeaponId,
      weaponKind,
      objectType,
      objectCircunstance,
      destinationObjectId,
      animalSpecie,
      animalCircunstance,
      destinationAnimalId,
      actionTaken, // novo
      auxiliaryOrgans, // adicionar aqui
    )
    setStartDate(null)
    setFinishDate(null)
    initialPeriod.set('')
    setFilters({})
    clearFilters?.()
  }

  const handlers = useMemo(
    () => ({
      involved: () => {
        setFilters({
          involvedType: involvedType.get(),
          arrested: arrestedId.get()?.toString(),
          peopleCircunstance: peopleCircunstanceId.get(),
          destinationFinal: destinationInvolvedId.get(),
          period: initialPeriod.get(),
        } as InvolvedFilter)
        return fetchAllAssociatedPeopleData({
          startDate,
          finishDate,
          arrested: arrestedId.get(),
          destinationId: destinationInvolvedId.get()?.id,
          involvementTypeId: involvedType.get()?.id,
          peopleCircunstanceId: peopleCircunstanceId.get()?.id,
        })
      },
      vehicle: () => {
        setFilters({
          period: initialPeriod.get(),
          destinationFinal: destinationVehicleId.get(),
          typeVehicle: vehicleType.get(),
          vehicleCiscunstance: vehicleCiscunstance.get(),
        } as VehicleFilter)
        return fetchAllAssociatedVehicleData({
          startDate,
          finishDate,
          destinationId: destinationVehicleId.get()?.id,
          involvementTypeId: vehicleType.get()?.id,
          vehicleCircunstanceId: vehicleCiscunstance.get()?.id,
        })
      },
      drugs: () => {
        setFilters({
          period: initialPeriod.get(),
          drugType: drugType.get(),
          drugCategory: drugSituation.get(),
          destinationFinal: destinationDrugId.get(),
        } as DrugsFilter)
        return fetchAllAssociatedDrugsData({
          startDate,
          finishDate,
          drugTypeId: drugType.get()?.id ?? null,
          destinationId: destinationDrugId.get()?.id ?? null,
          circunstanceId: drugSituation.get()?.id ?? null,
        })
      },
      weapon: () => {
        setFilters({
          period: initialPeriod.get(),
          weaponType: weaponType.get(),
          weaponCategory: weaponKind.get(),
          destinationFinal: destinationWeaponId.get(),
          weaponBrand: weaponCircunstance.get(),
        } as WeaponFilter)
        return fetchAllAssociatedWeaponData({
          startDate,
          finishDate,
          weaponTypeId: weaponType.get()?.id ?? null,
          destinationId: destinationWeaponId.get()?.id ?? null,
          circunstanceId: weaponCircunstance.get()?.id ?? null,
          weaponKindId: weaponKind.get()?.id ?? null,
        })
      },
      objects: () => {
        setFilters({
          period: initialPeriod.get(),
          objectType: objectType.get(),
          objectCategory: objectCircunstance.get(),
          destinationFinal: destinationObjectId.get(),
        } as ObjectsFilter)
        return fetchAllAssociatedObjectData({
          startDate,
          finishDate,
          objectTypeId: objectType.get()?.id ?? null,
          destinationId: destinationObjectId.get()?.id ?? null,
          circunstanceId: objectCircunstance.get()?.id ?? null,
        })
      },
      animals: () => {
        // novo
        setFilters({
          period: initialPeriod.get(),
          animalSpecies: animalSpecie.get(),
          destinationFinal: destinationAnimalId.get(),
          animalCircunstance: animalCircunstance.get(),
        } as AnimalsFilter)
        return fetchAllAssociatedAnimalsData({
          startDate,
          finishDate,
          specieId: animalSpecie.get()?.id ?? null,
          destinationId: destinationAnimalId.get()?.id ?? null,
          circunstanceId: animalCircunstance.get()?.id ?? null,
        })
      },
      organs: () => {
        setFilters({
          period: initialPeriod.get(),
          actionTakenId: actionTaken.get(),
          auxiliaryOrgans: auxiliaryOrgans.get(),
          
        } as OrgansFilter) // OrgansFilter está no union de setFilters
        return fetchAllAssociatedOrgansData({
          startDate,
          finishDate,
          actionTakenId: actionTaken.get()?.id ?? null,
          auxiliaryOrgansId: auxiliaryOrgans.get()?.id ?? null,
        })
      },
    }),
    [
      startDate,
      finishDate,
      initialPeriod,
      involvedType,
      arrestedId,
      peopleCircunstanceId,
      destinationInvolvedId,
      destinationVehicleId,
      vehicleType,
      vehicleCiscunstance,
      drugType,
      drugSituation,
      destinationDrugId,
      weaponType,
      weaponKind,
      weaponCircunstance,
      destinationWeaponId,
      objectType,
      objectCircunstance,
      destinationObjectId,
      animalSpecie,
      animalCircunstance,
      destinationAnimalId,
      actionTaken, // novo
      auxiliaryOrgans, // adicionar aqui
      fetchAllAssociatedPeopleData,
      fetchAllAssociatedVehicleData,
      fetchAllAssociatedDrugsData,
      fetchAllAssociatedWeaponData,
      fetchAllAssociatedObjectData,
      fetchAllAssociatedAnimalsData,
      fetchAllAssociatedOrgansData, // novo
      setFilters,
    ]
  )

  const searchInfo = () => {
    if (!startDate || !finishDate) {
      notify({
        type: 'error',
        message: translate('Enter a start and end date'),
      })
      return
    }
    const fn = valueTab && handlers[valueTab]
    fn?.().finally(() => searchButton?.())
  }

  const filtersComponent = (() => {
    switch (valueTab) {
      case 'drugs':
        return (
          <DrugFilters
            drugType={drugType}
            drugSituation={drugSituation}
            destinationDrugId={destinationDrugId}
            getDestinations={getDestinations}
            getDrugTypes={getDrugTypes}
            getCircunstances={getCircunstances}
            translate={translate}
            disableFields={disableFields}
            setStartDate={setStartDate}
            setFinishDate={setFinishDate}
            initialPeriod={initialPeriod}
          />
        )
      case 'weapon':
        return (
          <WeaponFilters
            weaponType={weaponType}
            weaponCircunstance={weaponCircunstance}
            destinationWeaponId={destinationWeaponId}
            getDestinations={getDestinations}
            getWeaponTypes={getWeaponTypes}
            getCircunstances={getCircunstances}
            getWeaponKinds={getWeaponKinds}
            translate={translate}
            disableFields={disableFields}
            setStartDate={setStartDate}
            setFinishDate={setFinishDate}
            initialPeriod={initialPeriod}
            weaponKind={weaponKind}
          />
        )
      case 'objects':
        return (
          <ObjectFilters
            objectType={objectType}
            objectCircunstance={objectCircunstance}
            destinationObjectId={destinationObjectId}
            getDestinations={getDestinations}
            getObjectTypes={getObjectTypes}
            getCircunstances={getCircunstances}
            translate={translate}
            disableFields={disableFields}
            setStartDate={setStartDate}
            setFinishDate={setFinishDate}
            initialPeriod={initialPeriod}
          />
        )
      case 'animals': // novo
        return (
          <AnimalsFilters
            animalSpecies={animalSpecie}
            animalCircunstance={animalCircunstance}
            destinationAnimalId={destinationAnimalId}
            getDestinations={getDestinations}
            getAnimalSpecies={getSpecies}
            getCircunstances={getCircunstances}
            translate={translate}
            disableFields={disableFields}
            setStartDate={setStartDate}
            setFinishDate={setFinishDate}
            initialPeriod={initialPeriod}
          />
        )
      case 'organs': // novo
        return (
          <OrgansFilters
            actionTaken={actionTaken}
            auxiliaryOrgans={auxiliaryOrgans}
            getActionTakens={getActionTaken} // corrigir nome da prop
            getAuxiliaryOrgans={getAuxiliaryOrgans}
            disableFields={disableFields}
            setStartDate={setStartDate}
            setFinishDate={setFinishDate}
            initialPeriod={initialPeriod}
          />
        )
      case 'involved':
        return (
          <InvolvedFilters
            involvedTypeFilter={involvedTypeFilter}
            arrestedFilter={arrestedFilter}
            peopleCircunstanceFilter={peopleCircunstanceFilter}
            destinationFinalFilter={destinationFinalFilter}
            involvedType={involvedType}
            arrestedId={arrestedId}
            peopleCircunstanceId={peopleCircunstanceId}
            destinationInvolvedId={destinationInvolvedId}
            getInvolvementTypes={getInvolvementTypes}
            getArrestedValues={getArrestedValues}
            getPeopleCircunstances={getPeopleCircunstances}
            getDestinations={getDestinations}
            translate={translate}
            disableFields={disableFields}
            setStartDate={setStartDate}
            setFinishDate={setFinishDate}
            initialPeriod={initialPeriod}
          />
        )
      default:
        return (
          <VehicleFilters
            destinationFinalFilter={destinationFinalFilter}
            typeVehicleFilter={typeVehicleFilter}
            vehicleCiscunstanceFilter={vehicleCiscunstanceFilter}
            destinationVehicleId={destinationVehicleId}
            vehicleType={vehicleType}
            vehicleCiscunstance={vehicleCiscunstance}
            getDestinations={getDestinations}
            getVehicleTypes={getVehicleTypes}
            getCircunstances={getCircunstances}
            translate={translate}
            disableFields={disableFields}
            setStartDate={setStartDate}
            setFinishDate={setFinishDate}
            initialPeriod={initialPeriod}
          />
        )
    }
  })()

  return (
    <Collapse in={hidden}>
      <Grid
        container
        xs={12}
        direction="row"
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          px: 2,
          pb: 2,
        }}
      >
        {filtersComponent}
      </Grid>
      <FiltersFooter
        loading={loading}
        handleClearFilters={handleClearFilters}
        searchInfo={searchInfo}
        translate={translate}
        labelButton={labelButton}
      />
    </Collapse>
  )
}
